import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58f16119"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-top-overview-container" }
const _hoisted_2 = {
  key: 1,
  id: "no-data"
}
const _hoisted_3 = {
  key: 2,
  class: "feedback-top-overview"
}
const _hoisted_4 = { class: "content carousel-container" }
const _hoisted_5 = {
  key: "summary",
  class: "summary"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "summary-score" }
const _hoisted_8 = {
  key: 0,
  class: "nps-change"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: "responses" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  key: 0,
  class: "responses-stats"
}
const _hoisted_13 = { class: "stat-line" }
const _hoisted_14 = { class: "stat-line" }
const _hoisted_15 = { class: "stat-line" }
const _hoisted_16 = { class: "stat-line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Total Responses", -1))
const _hoisted_18 = { key: "surveys" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "survey-stats" }
const _hoisted_21 = { class: "stat-line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sent", -1))
const _hoisted_23 = { class: "stat-line" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Opened", -1))
const _hoisted_25 = { class: "stat-line" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Responded", -1))
const _hoisted_27 = { class: "stat-line" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Response Rate", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingCard = _resolveComponent("LoadingCard")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_EmptyPageState = _resolveComponent("EmptyPageState")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.forceShowLoading)
      ? (_openBlock(), _createBlock(_component_LoadingCard, {
          key: 0,
          borderless: true,
          variant: "default"
        }))
      : (!_ctx.npsSummary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_EmptyPageState, { colour: "white" }, {
              "icon-img": _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  id: "error-icon",
                  icon: _ctx.faWarning
                }, null, 8, ["icon"])
              ]),
              "header-text": _withCtx(() => [
                _createTextVNode("No overview data available")
              ]),
              "body-text": _withCtx(() => [
                _createTextVNode("There was an issue loading your feedback summary")
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Carousel, {
                onTouchstart: _ctx.onCarouselTouchStart,
                onTouchend: _ctx.onCarouselTouchEnd
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.mobileFilterActive
                                    ? _ctx.getOverviewText(
                                          _ctx.mobileQuestionType,
                                          _ctx.mobileFilterActive.time_unit,
                                          _ctx.mobileFilterActive.time_value
                                      )
                                    : ''), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Typography, {
                        key: "score",
                        component: "h1",
                        variant: "h1",
                        class: "nps-big"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatScore(
                                        _ctx.npsSummary.nps,
                                        _ctx.isFiveScoreQuestionType(
                                            _ctx.mobileQuestionType
                                        ),
                                        _ctx.$companyVars.has_display_csat_as_percentage,
                                        _ctx.mobileQuestionType,
                                        _ctx.$companyVars?.decimals
                                    )) + _toDisplayString(_ctx.npsSummary.percentageSign), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      (_ctx.npsChange)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(" Change " + _toDisplayString(_ctx.formatScore(
                                        _ctx.npsChange,
                                        _ctx.isFiveScoreQuestionType(
                                            _ctx.mobileQuestionType
                                        ),
                                        false,
                                        _ctx.mobileQuestionType,
                                        _ctx.$companyVars?.decimals
                                    )) + " ", 1),
                            (_ctx.npsChange)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "trend-caret-medium",
                                  src: _ctx.npsChangeIcon
                                }, null, 8, _hoisted_9))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.mobileFilterActive
                                    ? _ctx.getOverviewText(
                                          _ctx.mobileQuestionType,
                                          _ctx.mobileFilterActive.time_unit,
                                          _ctx.mobileFilterActive.time_value,
                                          false
                                      )
                                    : ''), 1),
                    (_ctx.npsStatsSummary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('PROMOTER')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.promoter.toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('PASSIVE')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.passive.toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('DETRACTOR')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.detractor.toLocaleString()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.total.toLocaleString()), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.mobileFilterActive
                                    ? _ctx.getOverviewText(
                                          _ctx.mobileQuestionType,
                                          _ctx.mobileFilterActive.time_unit,
                                          _ctx.mobileFilterActive.time_value,
                                          false
                                      )
                                    : ''), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.sent.toLocaleString()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.opened.toLocaleString()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.responded.toLocaleString()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary.responseRate.toFixed()) + "% ", 1)
                      ])
                    ])
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["onTouchstart", "onTouchend"])
            ])
          ])),
    _hoisted_29
  ]))
}